var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:document-linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 13.7282C4 8.70019 4 6.18552 5.56267 4.62419C7.12533 3.06286 9.63867 3.06152 14.6667 3.06152H17.3333C22.3613 3.06152 24.876 3.06152 26.4373 4.62419C27.9987 6.18686 28 8.70019 28 13.7282V19.0615C28 24.0895 28 26.6042 26.4373 28.1655C24.8747 29.7269 22.3613 29.7282 17.3333 29.7282H14.6667C9.63867 29.7282 7.124 29.7282 5.56267 28.1655C4.00133 26.6029 4 24.0895 4 19.0615V13.7282Z",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6665 13.7285H21.3332M10.6665 19.0618H17.3332",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinear);
export default __webpack_public_path__ + "static/media/linear.6e547f87597b251242549c78dead201c.svg";
export { ForwardRef as ReactComponent };